/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2370
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
var r = function () {
  function e() {}
  e.of = function (t, n) {
    var r = new e()
    r.bindings = t
    r.middleware = n
    return r
  }
  return e
}()
exports.ContainerSnapshot = r
